import React from 'react';
import styles from '../ModalHeader.module.scss';
import { Heading } from 'components/core';
import { Props as HeadingProps } from 'components/core/Typography/components/Heading/Heading';

type ModalHeaderHeadingProps = {
  type?: HeadingProps['type'];
  component?: HeadingProps['component'];
} & Omit<HeadingProps, 'type' | 'component'>;

export const ModalHeaderHeading = ({
  className,
  type = 'h4',
  component = 'h2',
  ...props
}: ModalHeaderHeadingProps) => {
  const classes = [styles.ModalHeaderHeading];
  if (className) classes.push(className);

  return (
    <Heading
      type={type}
      component={component}
      className={classes.join(' ')}
      {...props}
    />
  );
};
